import {Extras} from './Extras';
import * as moment from 'moment';
import {Moment} from 'moment';

export class Selection {
	get selectedHall(): Object {
		return this._selectedHall;
	}

	set selectedHall(value: Object) {
		this._selectedHall = value;
	}

	get selectedDate(): Moment {
		return this._selectedDate;
	}

	set selectedDate(value: Moment) {
		this._selectedDate = value;
	}

	get selectedTime(): string {
		return this._selectedTime;
	}

	set selectedTime(value: string) {
		this._selectedTime = value;
	}

	get extras(): Extras {
		return this._extras;
	}

	set extras(value: Extras) {
		this._extras = value;
	}


  constructor () {
    	this._selectedHall = null;
    	this._selectedDate = null;
    	this._selectedTime = null;
    	this._extras = new Extras();
  }


	private _selectedHall: Object;
	private _selectedDate: Moment;
	private _selectedTime: string;
	private _extras: Extras;
}
